import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { scale, verticalScale } from "../../utils/scale";
import Button from "../Button";
import color from "../../constants/color";

import PhoneBook from "../../assets/svg/PhoneBook";
export class AapkeContactsHeader extends React.Component {
  render() {
    return (
      <View style={styles.mainContainer}>
        <View style={styles.titleContainer}>
          <Text style={styles.titleText}>{this.props.title}</Text>
        </View>
        {this.props.isBtn ? (
          <TouchableOpacity
            style={[this.props.style, styles.phonebookTouchable]}
            onPress={this.props.btnPress}
          >
            <View style={styles.phonebookContainer}>
              <PhoneBook />
            </View>
            <Text style={styles.btnText}>{this.props.btnText}</Text>
          </TouchableOpacity>
        ) : null}
      </View>
    );
  }
}
const styles = StyleSheet.create({
  titleText: {
    fontSize: scale(20),
    lineHeight: 28,
    fontFamily: "Mukta",
    fontStyle: "normal",
    fontWeight: "bold",
  },
  mainContainer: {
    height: verticalScale(67),
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
  },

  titleContainer: {
    width: scale(245),
    marginLeft: scale(15),
    marginVertical: verticalScale(10),
  },
  phonebookTouchable: {
    backgroundColor: "transparent",
    flexDirection: "row",
    height: verticalScale(28),
    width: scale(96),
    borderRadius: scale(30),
    borderWidth: 1,
    borderColor: color.black,
    alignItems: "center",
  },
  phonebookContainer: {
    alignSelf: "center",
    marginLeft: scale(15),
    height: "100%",
    justifyContent: "center",
    marginLeft: scale(8),
  },
  btnText: {
    fontSize: scale(14),
    marginLeft: scale(5),
    lineHeight: verticalScale(20),
    color: color.black,
  },
});
